<div class="w-100">
  <div class="w-100">
    <welcome></welcome>
  </div>
  <div class="px-4">
    <div class="home-section">
      <additonal-services
        [additionalServices]="additionalServices"
        [isFetching]="isFetchingAdditionalServices"
      ></additonal-services>
    </div>
    @if (solutions.length > 0) {
      <div class="home-section">
        <solutions [solutions]="solutions" [isFetching]="isFetchingSolutionsEvents"></solutions>
      </div>
    }
  </div>
</div>
<router-outlet></router-outlet>
